import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgTrophyIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      className="trophy_svg__st0"
      d="M348.375 384.758c-12.811-25.137-32.785-44.594-56.582-54.492v-38.5l.047-9.133c-.016 0-.031 0-.047.004v-.242a186.653 186.653 0 0 1-35.791 3.481c-11.369 0-22.476-1.094-33.291-3.055-.752-.152-1.516-.262-2.264-.426v.043c-.08-.016-.16-.028-.24-.043v47.871c-12.209 5.078-23.393 12.695-33.137 22.293-.348.34-.705.66-1.049 1.004-1.072 1.082-2.1 2.219-3.133 3.348-.705.77-1.426 1.512-2.115 2.305-.61.703-1.184 1.442-1.78 2.156-1.07 1.289-2.14 2.574-3.168 3.918-.088.117-.17.238-.26.355a131.672 131.672 0 0 0-11.939 18.875h.131c-.043.082-.09.16-.131.238h184.749zM115.046 416v95.371l-.002.387h.002V512h281.911v-96zM498.331 29.387c-8.027-9.094-19.447-14.312-31.328-14.312h-47.744V0H92.742v15.074H44.999c-11.887 0-23.306 5.218-31.336 14.312C3.906 40.442-.305 56.43 1.775 74.465c.369 7.922 4.367 49.316 47.211 78.77 24.732 17.008 48.424 24.629 69.44 27.938 29.008 45.328 79.76 75.398 137.576 75.398 57.805 0 108.558-30.07 137.568-75.398 21.016-3.305 44.709-10.93 69.445-27.938 42.84-29.453 46.842-70.848 47.211-78.77 2.078-18.035-2.133-34.023-11.895-45.078zm-22.093 41.629-.125.852-.002 1.031c-.029 1.246-1.115 30.656-32.447 52.195-8.976 6.172-17.635 10.719-26.041 14.184-1.836.711-3.668 1.43-5.553 2.043a163.215 163.215 0 0 0 7.19-48.008V49.226h47.744c1.498 0 3.711.481 5.726 2.758 3.279 3.719 4.558 10.653 3.508 19.032zm-222.274 84.203-33.658 18.73a4.166 4.166 0 0 1-4.49-.274 4.17 4.17 0 0 1-1.644-4.18l7.412-37.801a4.165 4.165 0 0 0-1.254-3.863l-28.213-26.23c-1.191-1.106-1.633-2.805-1.129-4.352s1.859-2.664 3.474-2.859l38.236-4.633a4.185 4.185 0 0 0 3.291-2.391l16.219-34.93a4.18 4.18 0 0 1 3.795-2.422c1.625 0 3.102.945 3.787 2.422l16.22 34.93a4.184 4.184 0 0 0 3.289 2.391l38.236 4.633a4.183 4.183 0 0 1 2.347 7.211l-28.215 26.23a4.168 4.168 0 0 0-1.26 3.863l7.418 37.801a4.163 4.163 0 0 1-1.648 4.18 4.163 4.163 0 0 1-4.486.274l-33.664-18.73a4.198 4.198 0 0 0-4.063 0zM68.331 125.094c-31.326-21.539-32.41-50.949-32.438-52.016l-.006-1.035-.131-1.027c-1.043-8.379.232-15.312 3.516-19.031 2.01-2.277 4.222-2.758 5.726-2.758H92.74v44.086c0 14.246 1.928 28.02 5.357 41.192.559 2.308 1.076 4.629 1.725 6.926-10.09-3.63-20.565-8.829-31.491-16.337z"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgTrophyStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgTrophyIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const TrophyIcon: any = SvgTrophyStyle;
export default TrophyIcon;
